import React, {useMemo} from 'react';
import {createFeatureFlagsClient, FeatureFlagsProvider} from '@ezcater/feature-flags-react';
import {Route} from 'react-router-dom';
import {withTracking} from '@ezcater/tracking-react';
import {useEnvironment} from '../Environment';

const EzManageRouteNoAuth = ({component: Component, linkId, path}) => {
  const {featureFlagHost} = useEnvironment();
  const featureFlagsClient = useMemo(
    () =>
      createFeatureFlagsClient({
        host: featureFlagHost,
      }),
    [featureFlagHost]
  );
  return (
    <FeatureFlagsProvider client={featureFlagsClient}>
      <Route linkId={linkId} component={Component} path={path} />
    </FeatureFlagsProvider>
  );
};

export default withTracking(EzManageRouteNoAuth);
